import { apiRequest } from "./api";

export async function scrapeWebsiteContent(url) {
    try {
        if (!isValidWebsiteUrl(url)) {
            throw new Error('請輸入有效的網站網址');
        }

        // Check if it's a video website (which we don't want to process)
        if (isVideoWebsite(url)) {
            throw new Error('不支援視頻網站，請輸入文字內容網站');
        }

        const result = await apiRequest('POST', '/api/index/websiteToText', {
            url
        })
        
        // Return the structured data directly
        return result;
    } catch (error) {
        console.error('Website scraping error:', error);
        throw error;
    }
}

function isValidWebsiteUrl(url) {
    try {
        const urlObj = new URL(url);
        return urlObj.protocol === 'http:' || urlObj.protocol === 'https:';
    } catch (e) {
        return false;
    }
}

function isVideoWebsite(url) {
    const videoSites = [
        'youtube.com', 'youtu.be', 'vimeo.com', 'dailymotion.com', 
        'twitch.tv', 'tiktok.com', 'instagram.com/reel', 'instagram.com/tv',
        'facebook.com/watch', 'bilibili.com', 'nicovideo.jp',
        'netflix.com', 'hulu.com', 'disney.com', 'disneyplus.com',
        'crunchyroll.com', 'funimation.com', 'viki.com'
    ];
    
    try {
        const hostname = new URL(url).hostname;
        return videoSites.some(site => hostname.includes(site));
    } catch (e) {
        return false;
    }
}

function calculateWordCount(text) {
    if (!text) return 0;
    
    // For Chinese text, count characters
    const isChinese = /[\u4e00-\u9fa5]/.test(text);
    
    if (isChinese) {
        // Remove spaces and punctuation
        const cleanText = text.replace(/[\s\p{P}]/gu, '');
        return cleanText.length;
    } else {
        // For English and other languages, count words
        return text.trim().split(/\s+/).length;
    }
}

function calculateReadingTime(text) {
    if (!text) return '0 分鐘';
    
    // For Chinese text, average reading speed is about 300 characters per minute
    // For English text, average reading speed is about 200 words per minute
    const isChinese = /[\u4e00-\u9fa5]/.test(text);
    
    let wordCount;
    let wordsPerMinute;
    
    if (isChinese) {
        // Count characters for Chinese text
        const cleanText = text.replace(/[\s\p{P}]/gu, '');
        wordCount = cleanText.length;
        wordsPerMinute = 300; // characters per minute
    } else {
        // Count words for non-Chinese text
        wordCount = text.trim().split(/\s+/).length;
        wordsPerMinute = 200; // words per minute
    }
    
    const minutes = Math.ceil(wordCount / wordsPerMinute);
    return `${minutes} 分鐘`;
}
